<template>
  <div>
    <v-snackbar centered v-model="snackbar.active" :color="snackbar.color" :timeout="2000" >
      <span>{{snackbar.message}}</span>
    </v-snackbar>
    <v-snackbar centered v-model="snackbar2.active" :color="snackbar2.color" :timeout="2000" >
      <span>{{snackbar2.message}}</span>
    </v-snackbar>            
    <v-row class="ma-2">
      <v-col cols="8" class="float-left">       
        <v-btn-toggle v-model="activeHall" mandatory active-class="info white--text" class="d-inline mr-8">
          <template v-for="(h,hi) in halls">
            <v-btn :key="hi" dark :value="hi">{{h.hallName}}</v-btn>
          </template>
        </v-btn-toggle>
        <v-btn class="mr-2" large color="info" fab icon dark @click.stop="GetData()"><v-icon>mdi-sync-circle</v-icon></v-btn>
        <v-btn class="mr-2" large color="info" fab icon dark @click.stop="openAddTables()"><v-icon>mdi-plus-circle</v-icon></v-btn>
        <v-btn class="mr-2" large color="success" fab icon dark @click.stop="getVirtualHallData();dialog_save = true"><v-icon class="mr-2">mdi-content-save</v-icon></v-btn>
      </v-col> 
      <v-col cols="4">
        <!--<v-slider v-model="sliderValue" min="0" max="100" @change="handleSliderChange"></v-slider>-->
        <v-slider class="mt-2" min="0" max="100" @change="handleSliderChange"></v-slider>
      </v-col>       
    </v-row> 
    <v-row class="ml-2">
      <v-col cols="2" id="leftMenuC">
        <div class="table-container my-5"  id="leftMenuD">
          <div class="text-left  text-h5">Tavoli</div>
          <template v-if="tables&&tables.length">
            <v-btn 
              v-for="(t, i) in tables.filter(k=>k.hallId==halls[activeHall].hallId)"
              :key="i"
              :id="t.tableId"
              :name="t.name"
              :hall="t.hallId"
              :type="t.shape"
              :draggable="true"
              class="ma-1"
              :color="t.color"
              :repeatable="t.repeatable?1:0"
              :hidden="t.hidden == 1"
              small
              @dragstart="dragCard"
            >
              {{ t['name'] }}
            </v-btn>
          </template>
          <template v-else>
            <div class="mt-2">Nessun Tavolo da Posizionare</div>
          </template>
          <!--
          <template v-if="newTables">
            <v-btn 
              v-for="(t, i) in newTables.split(',')"
              :key="i"
              :id="i"
              :tableId='i'
              :name="t.name"
              type="rounded"
              class="ma-1"
              color="#42a5f5"
              :draggable="true"


              @dragstart="dragCard"
            >
              {{ t }}
            </v-btn> 
          </template>  
          -->     
        </div>
        <v-divider class="py-3"></v-divider>
        <div class="text-left  my-2 text-h5">Shapes</div>
        <div class="action-container ml-5 text-left">
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('rounded')"><v-icon>mdi-square</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('round')"><v-icon>mdi-circle</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('ellipse')"><v-icon>mdi-ellipse</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('exa')"><v-icon>mdi-hexagon</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('octa')"><v-icon>mdi-octagon</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="setShape('triangle')"><v-icon>mdi-triangle</v-icon></v-btn>
        </div>
        <v-divider class="py-3"></v-divider>
        <div class="text-left mt-2 text-h5">Modifiers</div>
        <div class="action-container ml-5 text-left">
          <!-- <v-btn class="mr-2 mb-2" :color="isRotate?'info': ''" dark @click="SetCamera"><v-icon>mdi-rotate-right</v-icon></v-btn> -->
          <v-btn class="mr-2 mb-2" color="info" dark @click="SetFlipX()"><v-icon>mdi-flip-horizontal</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="SetFlipY()"><v-icon>mdi-flip-vertical</v-icon></v-btn>
          <br />
          <v-btn class="mr-2 mb-2" color="error" dark @click="DelTable()"><v-icon>mdi-delete</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="info" dark @click="SetColor('#42a5f5')"><v-icon>mdi-thumb-up</v-icon></v-btn>
          <v-btn class="mr-2 mb-2" color="error" dark @click="SetColor('#d50000')"><v-icon>mdi-thumb-down</v-icon></v-btn>
          <!--<input type="color" class="btn" @change="SetColor_old">-->
          <!--
          <div>
            <v-text-field
              v-model="inputW"
              type="number"
              label="Canvas Width"
              outlined
              @change="handleCanvasWidth"
            ></v-text-field>
            <v-text-field
              v-model="inputH"
              type="number"
              label="Canvas Height"
              outlined
              @change="handleCanvasHeight"
            ></v-text-field>
          </div>
          -->
        </div>
        <v-divider class="py-3"></v-divider>
        <div class="text-left mt-2 text-h5">Building Elements</div>
        <div class="arch-container ml-5 text-left" v-if="hallElements">
          <v-btn
            v-for="(t, i) in hallElements"
            :key="i"
            :id="t.elementId"
            :name="t.elementName"
            :hall="null"
            :type="t.shape"
            :draggable="true"
            class="ma-2"
            color="info"
            :repeatable="t.repeatable?1:0"
            @dragstart="dragCard"
          >
            <v-icon>{{t.icon}}</v-icon>
            {{ t.elementName }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="10">
        <div class="warp-container">
          <div class="wrap">
            <div>
              <canvas id="mycanvas" @drop="dropCard" @dragover="allowDropCard"></canvas>
            </div>
          </div>
          <div class="wrap2">
            <div>
              <canvas id="mycanvas2"></canvas>
            </div>
          </div>

          <div class="warp-container"
            v-if="isHandleAnchor()"
            :style="{ zIndex: 5 }">

            <!-- <div class="top-line line-h"></div>
            <div class="bottom-line line-h"></div>
            <div class="left-line line-v"></div>
            <div class="right-line line-v"></div> -->

            <!-- <div class="top-line line-h" :style="{ 
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, -' + (selDivStyle.hH + 2) + 'px)',
                width: selDivStyle.imgWidth + 'px', 
                margin: '0 0 0 -' + selDivStyle.hW + 'px',
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
              }"></div>
            <div class="bottom-line line-h" :style="{ 
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, ' + selDivStyle.hH + 'px)',
                width: selDivStyle.imgWidth + 'px', 
                margin: '0 0 0 -' + selDivStyle.hW + 'px',
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
              }"></div>
            <div class="right-line line-v" :style="{ 
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + selDivStyle.hW + 'px, 0)',
                height: selDivStyle.imgHeight + 'px', 
                margin: '-' + selDivStyle.hH + 'px 0 0 0',
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
              }"></div>
            <div class="left-line line-v" :style="{ 
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + (selDivStyle.hW + 2) + 'px, 0)',
                height: selDivStyle.imgHeight + 'px', 
                margin: '-' + selDivStyle.hH + 'px 0 0 0',
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
              }"></div> -->

            <div class="top-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, -' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="bottom-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, ' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="right-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW) + 'px, 0)',
              }"
            ></div>
            <div class="left-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + selDivStyle.hW + 'px, 0)',
              }"
            ></div>

            <!-- <div class="top-left-anchor anchor"
              @mousedown="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + selDivStyle.hW + 'px, -' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="top-right-anchor anchor"
              @mousedown="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + selDivStyle.hW + 'px, -' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="bottom-left-anchor anchor"
              @mousedown="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + selDivStyle.hW + 'px, ' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="bottom-right-anchor anchor"
              @mousedown="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + selDivStyle.hW + 'px, ' + selDivStyle.hH + 'px)',
              }"
            ></div> -->

            <!-- Anchor Transform -->
            <div class="top-left-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + (selDivStyle.hW + 18) + 'px, -' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="top-right-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW + 18) + 'px, -' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="bottom-right-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + (selDivStyle.hW + 18) + 'px, ' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="bottom-left-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW + 18) + 'px, ' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
          </div>
          
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog_new"
      max-width="800"
      style="overflow:hidden"
      v-if="halls"
    >
      <v-card>
        <v-card-title class="text-h5">
          Crea Tavoli per la sala <span class="info--text ml-2">{{halls[activeHall].hallName}}</span>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn  icon fab v-bind="attrs" v-on="on" class="mr-6">
                <v-icon color="success" @click="addTables()">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva Nuovi Tavoli</span>
          </v-tooltip>              
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">              
              <v-btn  fab icon @click="newTables=null;dialog_new = false"  v-bind="attrs" v-on="on">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Esci</span>
          </v-tooltip>               
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <v-row class="neu-glow pa-4">
            <v-col cols="12">
              <v-textarea
                  v-model="newTables"
                  counter="500"
                  label="Nomi Tavoli"
                  outlined
                  auto-grow
                  rows="3"
                  row-height="30"
                  hint="Inserisci in sequenza i nomi dei tavoli separandoli con una virgola"
              ></v-textarea>
            </v-col>
          </v-row>
          <!--
          <v-row>
            <v-col cols="2" v-for="i in 32" :key="i">
              <v-text-field
                v-model="newTablesArray[i]"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          -->
          <v-row class="neu-glow pa-4 mt-6">
            <v-col cols="3">
              <v-text-field
                v-model="newTablesWidth"
                label="Larghezza Tavolo"
                type="number"
                step="10"
                reverse
                outlined
                dense
                hint="in centimetri"
              ></v-text-field>
            </v-col> 
            <v-col cols="3">
              <v-text-field
                v-model="newTablesHeight"
                label="Lunghezza Tavolo"
                type="number"
                step="10"
                reverse
                outlined
                dense
                hint="in centimetri"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="newTablesShape"
                :items="shapes"
                outlined
                dense
                label="Forma Tavoli"
                hint="E' possibile modificare la forma in Seguito"
              >
              </v-select>
            </v-col>                        
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_save"
      max-width="600"
      style="overflow:hidden"
    >
      <v-card>
        <v-card-title class="text-h5">
          Salva Modifiche
          <v-spacer></v-spacer>
          <v-btn float icon>
            <v-icon color="success" :loading="loading" :disabled="JSON.stringify(halls)==loadedHalls" @click="saveHalls()">mdi-content-save</v-icon>
          </v-btn>
          <v-btn float icon @click="dialog_save=false">
            <v-icon color="info">mdi-close</v-icon>
          </v-btn>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4 text-h5">
          Confermi Salvataggio?
        </v-card-text>
        <!--
        <v-card-text class="mt-3">
          {{JSON.stringify(this.halls)}}
        </v-card-text>
        -->
      </v-card>
    </v-dialog> 
	</div>
</template>

<script>
  import Square from "./Square";
  import {DIRECTION} from "./Constant";
  import { mapGetters } from "vuex";
  export default {
    name: 'CanvasHall',
    data() {
      return {
        dialog_save:false,
        dialog_new:false,
        hall:{},
        activeHall:0,
        halls:null,
        tables:null,
        hallElements:null,
        snackbar:{active:0,color:null,message:null},
        snackbar2:{active:0,color:null,message:null},
        loadedHalls:null,
        newTables:null,
        inputTables:null,
        wHeight: window.innerHeight,
        wWidth: window.innerWidth,
        leftMenuC:null,
        leftMenuD:null,

        closeEnough: 10,
        dragTL: false,
        dragBL: false,
        dragTR: false,
        dragBR: false,
        drag: false,
        mouseX: null,
        mouseY: null,
        widthPercent: 0.8,
        heightPercent: 0.8,
        zoomLevel: 1,
        prtcls: [],
        startPos: {},
        canvas: null,
        canvas2: null,
        ctx: null,
        ctx2: null,
        w: 0,
        h: 0,
        inputW : 0,
        inputH : 0,        
        camera: {
          x : 0,
          y : 0
        },
        setting: {
          diff: 10
        },
        isCameraMove: false,
        isRotate: false,
        isScale: false,
        isAnchorStatus: false,
        scale_direction: DIRECTION.LEFT,

        lastTap : 0,
        timeout : null,
        pinchStartDistance : 0,
        initialZoom : 1,
        isPressed : false,
        pressTimer : null,

        selDivStyle: { 
          imageUrl: 'path/to/image.jpg',
          imgWidth: 0,
          imgHeight: 0,
          imgAngle: 0,
          hW: 0,
          hH: 0,
          fX: 0,
          fY: 0,
        },
        loading:false,
        shapes:[{"value":"rounded","text":"Quadrato"},{"value":"round","text":"Tondo"}],
        newTablesWidth:80,
        newTablesHeight:80,
        newTablesShape:'rounded',
        newTablesArray:[],
        defaultParelData: {
          "active":true,
          "tableId": "--",
          "tableName": "--",
          "width": 80,
          "height": 80,
          "shape": "rounded",
          "expandX": true,
          "expandY": true,
          "lockRatio": false,
          "x": 0,
          "y": 0
        },
      }
    },
    created(){
      console.log(1357,this.settings)
      //this.$vuetify.theme.dark = this.settings.options.darkTheme;
      //this.$store.dispatch("scheme/setDarkTheme", true);
      console.log(716,this.settings);
      if (this.settings&&this.settings.brand==' ')
      {
        this.$router.push('/auth/login').catch(() => {});
      }
      else
      {
        this.GetData(0)
      }
    },
    watch:
    {
      activeHall(newVal,oldVal)
      {
        console.log(431,newVal,oldVal);
        this.initTables(newVal)
      }
    },
    computed : {
      ...mapGetters(["settings"])
    },
    mounted() {
      this.canvas = document.getElementById('mycanvas')
      this.canvas2 = document.getElementById('mycanvas2')
      this.ctx = this.canvas.getContext('2d')
      this.ctx2 = this.canvas2.getContext('2d')
      this.w = this.canvas.width = this.canvas2.width = window.innerWidth * this.widthPercent;
      this.h = this.canvas.height = this.canvas2.height = window.innerHeight -285;//* this.heightPercent;

      this.leftMenuC=document.getElementById('leftMenuC')
      this.leftMenuD=document.getElementById('leftMenuD')
      console.log(1250,window.innerWidth, window.innerheight,this.w,this.h)
      console.log(1251,this.leftMenuC,this.leftMenuC.offsetWidth,this.leftMenuC.offsetHeight)
      console.log(1252,this.leftMenuD,this.leftMenuD.offsetWidth,this.leftMenuD.offsetHeight,this.leftMenuD.clientWidth,this.leftMenuD.clientHeight)  

      this.canvas.style.backgroundColor = 'transparent'
      this.canvas2.style.backgroundColor = '#f6f6f6'

      this.ctx.lineWidth = 2
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'middle'
      this.ctx.font = '10px Arial'
      
      this.drawBG(this.ctx2)

      // let arr = new Array(40).fill('empty').map(() => Math.floor(Math.random() * 100))


      window.addEventListener('resize', () => {
            this.w = this.canvas.width = this.canvas2.width = window.innerWidth * this.widthPercent;
            this.h = this.canvas.height = this.canvas2.height = window.innerHeight * this.heightPercent;
            this.drawBG(this.ctx2)
      })
      /*
      this.canvas.addEventListener('click', e => {
          // let mouse = this.getMouseCoords(this.canvas, e);
          //console.log(JSON.stringify(this.getIt()), e)
      })
      */

      this.canvas.addEventListener('dblclick', e => {
        this.handleSelect(e);

      })
      /*
      this.canvas.addEventListener("mousemove", e => {
        // this.handleSelect(e);
        if(!this.isAnchorStatus) {
          console.log("--------mouse move-----", this.isScale)
          let mouse = this.getMouseCoords(this.canvas, e);
          this.prtcls.forEach(e => {
            if (this.cursorInRect(mouse.x, mouse.y, e.x - 20, e.y - 20, e.w + 40, e.h + 40, e.angle)) {
                e.resize = true
            } else {
                e.resize = false
            }
          })
        }
      })*/



      window.addEventListener('mousemove', e => {
        this.handleMouseMove(e);
      })

      window.addEventListener('mousedown', e => {
        this.handleMouseDown(e);
      })

      window.addEventListener('mouseup', e => {
        this.handleMouseUp(e);
      })

      window.addEventListener('touchstart', (event) => {
        console.log("touch start")

        // ADD Keep press Event and select item
        if(!this.isRotate && !this.isScale) {
          this.isPressed = true;
          let that = this;
          this.pressTimer = setTimeout(function() {
            // Your code for "keep pressed" action here
            that.handleSelect(event.touches[0]);
            console.log("Keep pressed action");
          }, 200); // Adjust the duration (in milliseconds) as needed
        }



        this.detectDoubleTap(event.touches[0])

        this.handleTouchStart(event);
        // Check if there are at least two touch points
        if (event.touches.length >= 2) {
          this.canvas.classList.add('hand');
          this.startPos = {
            x : event.touches[0].clientX,
            y : event.touches[0].clientY,
            originX: this.camera.x,
            originY: this.camera.y
          }
        }
        
        this.handleMouseDown(event.touches[0]);
      });

      // Add an event listener to the touchmove event
      window.addEventListener('touchmove', (event) => {
        console.log("touch move-----")

        this.handleTouchMove(event);
        // Check if there are at least two touch points
        let e = event.touches[0];
        if (event.touches.length >= 2) {       
          console.log(e.clientX)   
          let diff = {
              //x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              //y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
              x : Math.round((e.clientX - this.startPos.x) / this.setting.diff) * this.setting.diff,
              y : Math.round((e.clientY - this.startPos.y) / this.setting.diff) * this.setting.diff,
          };
          // Handle the two-finger touch movement
          this.camera.x = this.startPos.originX + diff.x;
          this.camera.y = this.startPos.originY + diff.y;
          this.camera.x = Math.min(0, this.camera.x);
          this.camera.y = Math.min(0, this.camera.y);
          this.drawBG(this.ctx2)
        }

        this.handleMouseMove(event.touches[0])

      });



      
      window.addEventListener('touchend', (event) => {
        this.isPressed = false;
        clearTimeout(this.pressTimer);

        event.width = 1;
        this.handleMouseUp(event);
      })

      this.canvas.addEventListener("contextmenu", e => {
          //event.preventDefault();
        console.log(e)
      });

      this.canvas.addEventListener('wheel', this.handleScroll);

      // document.getElementsByClassName("rotate").addEventListener("mousedown", e => {
      //   this.mouseDown(e)
      // })

      

      this.animate()

      // this.drawSelection();

    },

    methods:{
      openAddTables()
      {
        console.log(608,this.activeHall)
        this.dialog_new=true;
      },
      async addTables()
      {
        var tablesToSave=[];
        var nT={
          "active": true,
          "color": "#42a5f5",
          "tableId": "B67F9FACDDDFFA442EA00A65AFBCB41EF63A83B8",
          "name": "I1",
          "shape": "rounded",
          "width": 80,
          "height": 80,
          "xPos": null,
          "yPos": null,
          "hallId": this.halls[this.activeHall],
          "expandX": 1,
          "expandY": 1,
          "locRatio": 0,
          "repeatable": 0
        };
        var nTables=this.newTables.split(',')
        this.newTables=null;
        var newArray=[];
        var duplicated=[];
        nTables.forEach(t=>{
          if(!this.halls[this.activeHall].tables.find(f=> f.name==t))
          {
            newArray.push(t)
          }
          else
          {
            duplicated.push(t)
          }
        })
        if (duplicated.length)
        {
          this.snackbar2.color='error'
          this.snackbar2.message='Valori duplicati: '+duplicated.join(',')
          this.snackbar2.active=true;          
        }

        newArray.forEach((t,ti)=>{
          var NT={...nT}
          NT.name=t.trim();
          NT.tableId=ti;
          NT.width=this.newTablesWidth;
          NT.height=this.newTablesHeight;
          NT.shape=this.newTablesShape;
          NT.hallId=this.halls[this.activeHall].hallId
          //NT.yPos=ti*100
          console.log(637,JSON.stringify(NT))
          tablesToSave.push(NT);
          //this.tables.push(NT);
        })

        //this.newTables=this.inputTables;
        console.log(609,this.tables,tablesToSave)
        var w= await this.saveNewTables(tablesToSave)
        var k= await this.GetData(725)
        console.log(w,k)
        this.initTables(this.activeHall)
        this.dialog_new=false;
        this.snackbar.color='success'
        this.snackbar.message='Tavoli Creati'
        this.snackbar.active=true;
      },
      async saveNewTables(tts)
      {
        this.loading=true;
        this.dialog_connectionError=false;

        //try{
            const payload=JSON.stringify({"action":"TablesAdd_set","payload":tts});
            const res = await this.$http.post('/canvas/canvas.php', payload );
            console.log(351,res)
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  //document.title = this.settings.brand+' | '+this.page;
                  this.snackbar.message='Tavoli Agiunti'
                  this.snackbar.color='success';
                  this.snackbar.active=1;
                  this.dialog_save=false;
                  //return true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }/*  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }*/        
      },      
      async GetData(row)
      {
        console.log(344,row,this.date);
        this.loading=true;
        this.dialog_connectionError=false;
        //this.bookings_previous=this.bookings?JSON.parse(JSON.stringify(this.bookings)):null;
        //try{
            const payload=JSON.stringify({"action":"Canvas_get"});
            const res = await this.$http.post('/canvas/canvas.php', payload );
            console.log(351,res)
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  document.title = this.settings.brand+' | '+this.page;
                  sessionStorage.setItem('jwt', res.data.jwt);
                  console.log(657,res.data.payloads)
                  //this.expired=res.data.payloads.expired;
                  this.halls=res.data.payloads.halls;
                  this.tables=res.data.payloads.tables;
                  this.hallElements=res.data.payloads.hallElements;
                  this.loadedHalls=JSON.stringify(this.halls);
                  this.activeHall=0;
                  console.log(662,this.halls,this.activeHall);
                  this.initTables(0)
                  //return true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }/*  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }*/
      },
      async saveHalls()
      {
        this.loading=true;
        this.dialog_connectionError=false;

        //try{
            const payload=JSON.stringify({"action":"Canvas_set","payload":this.halls});
            const res = await this.$http.post('/canvas/canvas.php', payload );
            console.log(351,res)
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  //document.title = this.settings.brand+' | '+this.page;
                  this.snackbar.message='Mappa Tavoli Salvata'
                  this.snackbar.color='success';
                  this.snackbar.active=1;
                  this.dialog_save=false;
                  //return true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }/*  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }*/        
      },
      getOffsetCoords(mouse, rect) {
        return {
            x: mouse.x - rect.x,
            y: mouse.y - rect.y
        }
      },
      cursorInRect(mouseX, mouseY, rectX, rectY, rectW, rectH, angle = 0) {

        let realRect = this.getRealMouseRect(rectX, rectY, rectW, rectH, angle);

        // let x = rectX + this.camera.x;
        // let y = rectY + this.camera.y;

        // let xLine = mouseX > x && mouseX < x + rectW
        // let yLine = mouseY > y && mouseY < y + rectH
        
        //let xLine = mouseX > realRect.leftEdgeX && mouseX < realRect.rightEdgeX;
        //let yLine = mouseY > realRect.topEdgeY && mouseY < realRect.bottomEdgeY;

        let xLine = mouseX > (realRect.leftEdgeX + this.camera.x) && mouseX < (realRect.rightEdgeX + this.camera.x);
        let yLine = mouseY > (realRect.topEdgeY + this.camera.y) && mouseY < (realRect.bottomEdgeY + this.camera.y);


        return xLine && yLine
      },

      getRealMouseRect(x, y, width, height, rotation) {
        // Define the rectangle properties
        // const x = 200; // x-coordinate of the rectangle
        // const y = 200; // y-coordinate of the rectangle
        // const width = 100; // width of the rectangle
        // const height = 50; // height of the rectangle
        // const rotation = 45; // rotation angle in degrees

        // Convert the rotation angle to radians
        const angleInRadians = rotation;

        // Calculate the center point of the rectangle
        const centerX = x + width / 2;
        const centerY = y + height / 2;

        // Calculate the coordinates of the four corners
        const topLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const topRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const bottomLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        const bottomRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        /*
        // Calculate the x and y coordinates of the edges
        const leftEdgeXTemp = Math.min(topLeftX, bottomLeftX);
        const rightEdgeXTemp = Math.max(topRightX, bottomRightX);
        const topEdgeYTemp = Math.min(topLeftY, topRightY);
        const bottomEdgeYTemp = Math.max(bottomLeftY, bottomRightY);
        */
        const leftEdgeXTemp = Math.min(topLeftX, bottomLeftX, topRightX, bottomRightX);
        const rightEdgeXTemp = Math.max(topRightX, bottomRightX, topLeftX, bottomLeftX);
        const topEdgeYTemp = Math.min(topLeftY, topRightY, bottomLeftY, bottomRightY);
        const bottomEdgeYTemp = Math.max(bottomLeftY, bottomRightY, topLeftY, topRightY);

        const leftEdgeX = Math.min(leftEdgeXTemp, rightEdgeXTemp);
        const rightEdgeX = Math.max(leftEdgeXTemp, rightEdgeXTemp);
        const topEdgeY = Math.min(topEdgeYTemp, bottomEdgeYTemp);
        const bottomEdgeY = Math.max(topEdgeYTemp, bottomEdgeYTemp);

        return {
          topLeftX,
          topLeftY,
          topRightX,
          topRightY,
          bottomLeftX,
          bottomLeftY,
          bottomRightX,
          bottomRightY,
          leftEdgeX,
          rightEdgeX,
          topEdgeY,
          bottomEdgeY,
        }
      },


      handleScroll(event) {
        event.preventDefault(); // Prevent default scroll behavior

        const zoomSpeed = 0.1; // Adjust this value to control the zoom speed
        const scrollDelta = Math.sign(event.deltaY); // Get the scroll direction (1 for zoom in, -1 for zoom out)

        // Calculate the new zoom level
        this.zoomLevel -= scrollDelta * zoomSpeed;

        // Limit the zoom level to a specific range if desired
        // For example, you can use:
        this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));

        //   // Apply the zoom level to the canvas
        //   ctx2.clearRect(0, 0, canvas.width, canvas.height);
        //   ctx2.scale(zoomLevel, zoomLevel);

        // Redraw your canvas content here
        // ...
        this.drawBG(this.ctx2)

        // Reset the canvas scale to avoid cumulative scaling
          //   ctx2.setTransform(1, 0, 0, 1, 0, 0);
      },
      checkCloseEnough(p1, p2) {
          console.log(29,this.closeEnough)
          return Math.abs(p1 - p2) < this.closeEnough;
      },
      mouseUp() {
        this.dragTL = this.dragTR = this.dragBL = this.dragBR = false;
      },
      mouseDown(e,mouse) {
        //let mouse = getMouseCoords(canvas,this)
        console.log(41, e, mouse,this.dragTL,this.dragTR,this.dragBL,this.dragBR,this.mouseX,this.mouseY)
      },

      drawBG(context){
          context.clearRect(0, 0, this.canvas.width, this.canvas.height);
          context.scale(this.zoomLevel, this.zoomLevel);

          context.save()

          context.fillStyle = 'white'
          context.fillRect(0, 0, this.w / this.zoomLevel, this.h / this.zoomLevel)
          context.lineWidth = 0.3;
          context.strokeStyle = 'lightgray'
          context.fillStyle = 'black'
          console.log('width : ', this.w, 'canvas : ', this.canvas.width)
          for (let i = 1; i < this.w / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(i, 0);
                  context.lineTo(i, this.h / this.zoomLevel)
                  context.moveTo(i, 0);
              }
              context.closePath()
              context.stroke()
          }

          for (let i = 1; i < this.h / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(this.w / this.zoomLevel, i)
                  context.moveTo(0, i)
              }
              context.closePath()
              context.stroke()
          }


          context.lineWidth = 1
          context.strokeStyle = 'gray'

          context.beginPath()
          for (let i = 50; i < this.w / this.zoomLevel; i += 10) {
              if ((i - this.camera.x) % 50 === 0) {
                  context.moveTo(i, 0)
                  context.lineTo(i, 30)
                  context.fillText(` ${i - this.camera.x}`, i, 30)
              } else {
                  context.moveTo(i, 0)
                  context.lineTo(i, 10)
              }

          }
          context.closePath()
          context.stroke()

          context.beginPath()
          for (let i = 50 ; i < this.h / this.zoomLevel; i += 10) {
              if ((i - this.camera.y) % 50 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(30, i)
                  context.fillText(` ${i - this.camera.y}`, 30, i)
              } else {
                  context.moveTo(0, i)
                  context.lineTo(10, i)
              }

          }
          context.closePath()
          context.stroke()
          context.restore()

          context.setTransform(1, 0, 0, 1, 0, 0);
      },
      getMouseCoords(canvas, event) {
        let canvasCoords = canvas.getBoundingClientRect()
        return {
            x: (event.clientX - canvasCoords.left) / this.zoomLevel,
            y: (event.clientY - canvasCoords.top) / this.zoomLevel
        }
      },
      getIt(type = '') {
          let json = [];
          if(type == 'tables') {
            this.prtcls.forEach(e => {
                json.push({
                    "active":e.active,
                    "tableId": e.tableId,
                    "hallId": e.hallId,
                    "name": e.table,
                    "color": e.color,
                    "width": e.w,
                    "height": e.h,
                    "shape": e.shape,
                    "x": Math.floor(e.x/10)*10,
                    "y": Math.floor(e.y/10)*10,
                    "angle": Math.round(e.angle*10000000000)/10000000000
                    /*,
                    "expandX": e.expandX,
                    "expandY": e.expandY,
                    "lockRatio": e.lockRatio,
                    "flipX": 1,
                    "flipY": 1,*/
                });
              })
          } else {
            this.prtcls.forEach(e => {
              json.push({
                  name: e.table,
                  xPos: e.x,
                  yPos: e.y
              })
            })
          }

          return json;
      },
      setShape(type = 'rounded') {
          this.prtcls.forEach(e => {
              if(e.isChange) {
                  if(type == 'color') {
                      e.color = document.getElementById('color').value;
                  } else {
                      e.shape = type;
                      if(type == 'round') {
                          e.h = e.w;
                      }
                  }
              }
          })
      },
      allowDropCard(ev) {
          ev.preventDefault();
      },
      dragCard(ev) {
          ev.dataTransfer.setData("card", ev.target.id);
          ev.dataTransfer.setData("cardName", ev.target.getAttribute('name'));
          ev.dataTransfer.setData("cardType", ev.target.getAttribute('type'));
          ev.dataTransfer.setData("repeatable", ev.target.getAttribute('repeatable'));
      },
      dropCard(ev) {
          ev.preventDefault();
          let id = ev.dataTransfer.getData("card");
          let name = ev.dataTransfer.getData("cardName");
          let type = ev.dataTransfer.getData("cardType");
          let repeatable = ev.dataTransfer.getData("repeatable");
          // let json = {...this.defaultParelData};


          console.log(id, !repeatable, repeatable)

          if(id == '') return;
          if(repeatable == 0) {
            this.hideTable(id);
          }

          let canvasCoords = this.canvas.getBoundingClientRect()

          let json = this.tables.filter(t => t.tableId == id);
          if(json.length == 0) {
            json = this.hallElements.filter(a => a.elementId == id)[0];
            //json['elementId'] = json['elementId'];
            //json['elementName'] = json['elementName'];
          } else {
            json = json[0]
          }

          console.log(json)

          json['tableId'] = id;
          json['tableName'] = name;
          json['shape'] = type;
          //json['x'] = (Math.round((event.clientX - canvasCoords.left) / 10) * 10) / this.zoomLevel;
          //json['y'] = (Math.round((event.clientY - canvasCoords.top) / 10) * 10) / this.zoomLevel;
          json['x'] = (Math.round((event.clientX - canvasCoords.left) / this.setting.diff) * this.setting.diff) / this.zoomLevel;
          json['y'] = (Math.round((event.clientY - canvasCoords.top) / this.setting.diff) * this.setting.diff) / this.zoomLevel;

          let newPrtcls = new Square(json);
          this.prtcls.push(newPrtcls)
      },

      hideTable(id, val = 1) {            //val = 1 : HIDE, 0 : SHOW
        let index = this.tables.findIndex(t => t.tableId == id);
        if(index == -1) {
          index = this.hallElements.findIndex(a => a.elementId == id);
          let t = [...this.hallElements];
          t[index]['hidden'] = val;
          this.hallElements = [...t];
        } else {
          let t = [...this.tables];
          t[index]['hidden'] = val;
          this.tables = [...t];
        }
      },

      getVirtualHallData() {
        let tables = this.getIt('tables');
        this.halls[this.activeHall]['tables'] = tables;
        console.log("Virtual Hall Json Data :  ", this.halls)
      },

      isHandleAnchor() {
        let isAnchor = false;
        this.prtcls.forEach(e => {
          if(e.resize) {
            isAnchor = true;
          }
        })
        return isAnchor;
      },

      SetCamera() {
        this.isRotate = !this.isRotate;
      },

      SetFlipX() {
        this.prtcls.forEach((p) => {
          if(p.isChange) {
            p.flipX *= -1;
          }
        })
      },

      SetFlipY() {
        this.prtcls.forEach((p) => {
          if(p.isChange) {
            p.flipY *= -1;
          }
        })
      },

      DelTable() {
        let tableId = "";
        let index = -1;
        this.prtcls.forEach((p, i) => {
          if(p.isChange) {
            tableId = p.tableId;
            index = i;
          }
        })
        if(index != -1) {
          let p = [...this.prtcls];
          p = p.filter((t, i) => i !== index);
          this.prtcls = [...p];
        }

        this.hideTable(tableId, 0)
      },

      SetColor(c) {
        this.prtcls.forEach(p => {
          if(p.resize) {
            console.log(952,c)
            p.color = c;
          }
        })
      },
    SetColor_old(e) {
        this.prtcls.forEach(p => {
          if(p.resize)
          {
            console.log(961,e,e.target)
            p.color = e.target.value;
          }
        })
      },

      initTables(vH) {
          // let tableDiv = document.getElementById('tables-div');
          // tableDiv.innerHTML = this.tables.filter(t => t.virtualHallId == null).map((t, i) => `
          //     <div id="${t.tableId}" name="${t.tableName}" type="${i != 1? 'rect' : 'round'}" class="card ${i != 1? '' : 'round'}" draggable="true" ondragstart="dragCard(event)">
          //         <span>${t.tableName}</span>
          //     </div>
          // `)

          //let json = this.halls[i]['tables'];
          console.log(1071,vH,this.activeHall)
          console.log(1072,this.wHeight,this.wWidth,this.canvas.width,this.canvas.height)
          
          let json = this.halls[vH]['tables'];
          this.prtcls = new Array(json.length).fill().map((a,idx) => new Square(json[idx]))


          let height = this.halls[vH]['maxHeight'];//value.target.value;
          let width  = this.halls[vH]['maxWidth'];
          console.log(1131,this.w,this.h,width,height)
          console.log(1133,this.h+'>'+height+'&&'+this.w+'>'+width+'/('+height+'/'+this.h+')')
          console.log(1134,this.h+'>'+height+'&&'+this.w+'>'+width/(height/this.h))
          //var xt=20;
          
          if (width&&height)
          {
            /*
            if (this.h>height&&this.w>width/(height/this.h))
            {
              this.zoomLevel = this.h / (height+xt);
              this.canvas.width=width+xt
              this.canvas2.width=width+xt

              this.canvas.height=height+xt
              this.canvas2.height=height+xt            
              console.log(1136)
            }
            else
            {
              this.zoomLevel = this.w / (width+xt);
              this.canvas.height=height+xt
              this.canvas2.height=height+xt
              this.canvas.width=width+xt
              this.canvas2.width=width+xt            
              console.log(1141)
            }
            */
            //this.inputW = Math.round(this.w / this.zoomLevel);
            this.drawBG(this.ctx2)
            console.log(1081,width,height,this.w,this.h,this.zoomLevel);
          }
      },
      animate () {
          this.ctx.clearRect(0, 0, this.w, this.ctx.canvas.height)
          this.ctx.scale(this.zoomLevel, this.zoomLevel);

          this.ctx.fillStyle = 'white'
          let aa = [...this.prtcls];
          aa.reverse().forEach(e => {
              e.select = true
              e.camera = {...this.camera};
              e.draw(this.ctx)
              if(e.resize) {
                this.drawDragAnchor(e.x, e.y, e.w, e.h, e.angle);
              }
          })
          this.ctx.setTransform(1, 0, 0, 1, 0, 0);
          window.requestAnimationFrame(this.animate)
      },

      handleSelect(e) {
        let mouse = this.getMouseCoords(this.canvas, e);
        this.prtcls.forEach(e => {
          if (this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle)) {
              e.resize = true
              e.isChange = true
          } else {
              e.resize = false
              e.isChange = false
          }
        })

      },

      handleRotate(){
        console.log("----set rotate")

        this.isRotate = true;
        this.isAnchorStatus = true;
      },

      handleAnchors(event){
        if(event.toElement != undefined) {
          this.scale_direction = event.toElement.className.replace("-anchor anchor", "");
        } else {
          this.scale_direction = event.currentTarget.className.replace("-anchor anchor", "");
        }

        console.log("----set direction", this.scale_direction)
        this.isScale = true;
        this.isAnchorStatus = true;
      },

      drawSelection(){
        let w = 200;
        let h = 100
        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = this.camera.x + w + left + this.selDivStyle.hW;
        this.selDivStyle.fY = this.camera.y + h + top + this.selDivStyle.hH;

        console.log(this.canvas, this.canvas.top)
        console.log(this.selDivStyle.fX, this.selDivStyle.fY)
        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = Math.PI / 4; // Example angle of 45 degrees

        // //Position
        // $(".line-h, .line-v, .rotation-center, #preview").css("left", fX+"px").css("top", fY+"px").show();

        // $(".line-h").width(img.width).css("margin", "0 0 0 -"+hW+"px");
        // $(".line-v").height(img.height).css("margin", "-"+hH+"px 0 0 0");
        // $("#jq-preview").width(img.width).height(img.height).css("margin", "-"+hH+"px 0 0 -"+hW+"px"); 

        // $(".top-line").css("transform", "rotate("+img.angle+"rad) translate(0, -"+(hH+2)+"px)");
        // $(".bottom-line").css("transform", "rotate("+img.angle+"rad) translate(0, "+hH+"px)");
        // $(".right-line").css("transform", "rotate("+img.angle+"rad) translate("+hW+"px, 0)");
        // $(".left-line").css("transform", "rotate("+img.angle+"rad) translate(-"+(hW+2)+"px, 0)");
      },

      drawDragAnchor(x, y, w, h, angle){

        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        w = w * this.zoomLevel;
        h = h * this.zoomLevel

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = ( this.camera.x + x ) * this.zoomLevel + this.selDivStyle.hW + left;
        this.selDivStyle.fY = ( this.camera.y + y ) * this.zoomLevel + this.selDivStyle.hH  + top;

        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = angle; // Example angle of 45 degrees

        // Position
        // $(".anchor, .rotate").css("left", fX+"px").css("top", fY+"px").show();
        // // Line Transform
        // $(".top-anchor").css("transform", "rotate("+img.angle+"rad) translate(0, -"+hH+"px)");
        // $(".bottom-anchor").css("transform", "rotate("+img.angle+"rad) translate(0, "+hH+"px)");
        // $(".right-anchor").css("transform", "rotate("+img.angle+"rad) translate("+hW+"px, 0)");
        // $(".left-anchor").css("transform", "rotate("+img.angle+"rad) translate(-"+hW+"px, 0)");

        // // Anchor Transform
        // $(".top-left-anchor").css("transform", "rotate("+img.angle+"rad) translate(-"+hW+"px, -"+hH+"px)");
        // $(".top-right-anchor").css("transform", "rotate("+img.angle+"rad) translate("+hW+"px, -"+hH+"px)");
        // $(".bottom-left-anchor").css("transform", "rotate("+img.angle+"rad) translate(-"+hW+"px, "+hH+"px)");
        // $(".bottom-right-anchor").css("transform", "rotate("+img.angle+"rad) translate("+hW+"px, "+hH+"px)");

        // // Rotate Transform
        // $(".top-left-rotate").css("transform", "rotate("+img.angle+"rad) translate(-"+(hW+18)+"px, -"+(hH+18)+"px)");
        // $(".top-right-rotate").css("transform", "rotate("+img.angle+"rad) translate("+(hW+18)+"px, -"+(hH+18)+"px)");
        // $(".bottom-left-rotate").css("transform", "rotate("+img.angle+"rad) translate(-"+(hW+18)+"px, "+(hH+18)+"px)");
        // $(".bottom-right-rotate").css("transform", "rotate("+img.angle+"rad) translate("+(hW+18)+"px, "+(hH+18)+"px)");

      },

      rotate(e, mouse){

        var imageCenterX = e.x + (e.w / 2);
        var imageCenterY = e.y + (e.h / 2);
        // Math.round((e.clientX - this.startPos.x) / this.setting.diff) * this.setting.diff,


        var a = { x: mouse.x, y: mouse.y };
        var b = { x: imageCenterX, y: imageCenterY };
        var c = { x: this.startPos.x, y: this.startPos.y };

        var dir = this.ccw(a, b, c);

        var radians = this.getAngle(a, b, c);

        let diff = Math.PI / 18;

        radians = Math.round(radians / diff) * diff;

        e.angle = dir == -1 ? -radians + this.startPos.originAngle : radians + this.startPos.originAngle;

        
      },
      
      scale(e, diff){
		
        let dx = diff.x;
        let dy = diff.y;

        // var xs = dx * dx;
        // var ys = dy * dy;		 
        // var distance =  Math.sqrt( xs + ys );

          if(this.scale_direction == DIRECTION.RIGHT){
            e.w = this.startPos.originW + dx;
          }
          if(this.scale_direction == DIRECTION.LEFT){
            e.w = this.startPos.originW - dx;
            e.x = this.startPos.x + dx - this.camera.x;
          }
          if(this.scale_direction == DIRECTION.BOTTOM){
            e.h = this.startPos.originH + dy;
          }
          if(this.scale_direction == DIRECTION.TOP){
            e.h = this.startPos.originH - dy;
            e.y = this.startPos.y + dy - this.camera.y;
          }
          // if(this.scale_direction == "top-left"){
          //   img.height += -dy;
          //   img.top += dy;
          //   img.width += -dx;
          //   img.left += dx;	
          // }
          // if(this.scale_direction == "top-right"){
          //   img.height += -dy;
          //   img.top += dy;
          //   img.width += dx;
          // }
          // if(this.scale_direction == "bottom-right"){
          //   img.height += dy;
          //   img.width += dx;
          // }
          // if(this.scale_direction == "bottom-left"){
          //   img.height += dy;
          //   img.width += -dx;
          //   img.left += dx;				
          // }

      },

      getAngle(a, b, c){
        var AB = Math.sqrt(Math.pow(b.x-a.x,2)+ Math.pow(b.y-a.y,2));    
        var BC = Math.sqrt(Math.pow(b.x-c.x,2)+ Math.pow(b.y-c.y,2)); 
        var AC = Math.sqrt(Math.pow(c.x-a.x,2)+ Math.pow(c.y-a.y,2));
        return Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB));
      },

      ccw(a, b, c) {
        var area2 = (b.x - a.x)*(c.y - a.y) - (b.y - a.y)*(c.x - a.x);
        if (area2 < 0) return -1;
        if (area2 > 0) return +1;
        return 0;
      },

      detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - this.lastTap;

        if (tapLen < 500 && tapLen > 0) {
          // Double tap detected

          this.handleSelect(event);

          console.log('Double tapped!');
        } else {
          // Not a double tap, start a timer
          this.timeout = setTimeout(() => {
            clearTimeout(this.timeout);
          }, 500);
        }

        this.lastTap = curTime;
      },

      handleMouseMove(e) {
        let diff = {
              //x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              //y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
              x : Math.round((e.clientX - this.startPos.x) / this.setting.diff) * this.setting.diff,
              y : Math.round((e.clientY - this.startPos.y) / this.setting.diff) * this.setting.diff,
          };
          if(e.which == 2) {
            this.camera.x = this.startPos.originX + diff.x;
            this.camera.y = this.startPos.originY + diff.y;
            this.camera.x = Math.min(0, this.camera.x);
            this.camera.y = Math.min(0, this.camera.y);
            this.drawBG(this.ctx2)
          } else {
              let mouse = this.getMouseCoords(this.canvas, e)

              let arr = this.prtcls.map(e => this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle))
              !arr.every(e => e === false) ? this.canvas.classList.add('pointer') : this.canvas.classList.remove('pointer')

              this.prtcls.forEach(e => {
                  if (e.selected) {
                      //let newX = Math.round((mouse.x - e.offset.x)/10)*10
                      //let newY = Math.round((mouse.y - e.offset.y)/10)*10
                      let newX = Math.round((mouse.x - e.offset.x)/this.setting.diff) * this.setting.diff
                      let newY = Math.round((mouse.y - e.offset.y)/this.setting.diff) * this.setting.diff
                      if(e.resize && (this.isScale || this.isRotate)) {
                          let diff = {
                              x : Math.round((mouse.x - this.startPos.x) / this.setting.diff) * this.setting.diff,
                              y : Math.round((mouse.y - this.startPos.y) / this.setting.diff) * this.setting.diff,
                          }

                          if(this.isRotate) {
                            this.rotate(e, mouse)
                            // e.angle = this.startPos.originAngle + Math.PI / 18 * diff.x/10;

                          } else {

                            diff.x = e.expandX? diff.x : 0;
                            diff.y = e.expandY? diff.y : 0;

                            if(e.lockRatio) {
                                diff.y = diff.x * (e.h / e.w);
                            }

                            this.scale(e, diff)

                            //e.w = Math.max(10, e.w)
                            //e.h = Math.max(10, e.h)
                            e.w = Math.max(this.setting.diff, e.w)
                            e.h = Math.max(this.setting.diff, e.h)

                            // if(this.scale_direction == DIRECTION.LEFT) {
                            //     e.w = this.startPos.originW - diff.x;
                            //     // e.h = this.startPos.originH + diff.y;
                            //     e.x = this.startPos.x + diff.x


                            // } else {
                            //   if(e.shape == 'round') {
                            //     e.w = this.startPos.originW + diff.x;
                            //     e.h = this.startPos.originH + diff.x;
                            //   } else {
                            //       e.w = this.startPos.originW + diff.x;
                            //       e.h = this.startPos.originH + diff.y;
                            //   }
              
                            //   e.w = Math.max(10, e.w)
                            //   e.h = Math.max(10, e.h)
                            // }



                          }


                      } else {
                          e.x = newX
                          e.y = newY
                      }
                  }
                  this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle) ?
                      e.active != true ? e.activate() : false
                      : e.active = false
              })
          }
      },

      handleMouseDown(e) {
        console.log("is SCALE: ", this.isScale, " ROTATE: ", this.isRotate)
        if(e.which == 2) {
            console.log("camera move---")
            this.canvas.classList.add('hand');
            this.startPos = {
                  x : e.clientX,
                  y : e.clientY,
                  originX: this.camera.x,
                  originY: this.camera.y
              }
          } else {
            let mouse = this.getMouseCoords(this.canvas, e)
            console.log(1630,mouse)
            let isSelect = false;
            this.prtcls.forEach(e => {
             if (!isSelect && this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle)) {
                  isSelect = true
                  e.selected = true
                  e.offset = this.getOffsetCoords(mouse, e)
                  if(e.resize) {
                      this.startPos = {
                          x : mouse.x,
                          y : mouse.y,
                          originW : e.w,
                          originH : e.h,
                          originAngle : e.angle
                      }
                      e.rotate = this.isRotate;
                      console.log(1645,this.startPos)
                  } else {
                    e.rotate = false;
                  }
              } else if ((this.isScale || this.isRotate) && e.resize) {
                console.log("_____seeleect div")
                  e.selected = true
                  e.offset = this.getOffsetCoords(mouse, e)
                  this.startPos = {
                      x : mouse.x,
                      y : mouse.y,
                      originW : e.w,
                      originH : e.h,
                      originAngle : e.angle
                  }
                  e.rotate = this.isRotate;
              } else {
                  e.selected = false
              }
            })
          }
      },

      handleMouseUp(e) {
        //console.log("touch up")
        if(e.which == 2) {
          this.canvas.classList.remove('hand')
        } else {
          this.prtcls.forEach(e => {
            e.selected = false
          })
        }
        this.isScale = false;
        this.isRotate = false;
        this.isAnchorStatus = false;
      },

      handleTouchStart(event) {
        const touchPoints = Array.from(event.touches);
        if (touchPoints.length === 2) {
          // Calculate the initial distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          this.pinchStartDistance = Math.sqrt(dx * dx + dy * dy);
          this.initialZoom = 1;
        }
      },

      handleTouchMove(event) {
        const touchPoints = Array.from(event.touches);
        console.log("touch - length -----", touchPoints.length)
        if (touchPoints.length === 2) {
          // Calculate the current distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          const pinchCurrentDistance = Math.sqrt(dx * dx + dy * dy);

          // Calculate the zoom factor based on the pinch distance change
          const zoomFactor = pinchCurrentDistance / this.pinchStartDistance;


          const zoomSpeed = 0.1; // Adjust this value to control the zoom speed
          this.zoomLevel -= (zoomFactor > this.initialZoom ? 1 : -1) * zoomSpeed;
          this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));
          // Perform the zoom action based on the zoom factor
          if (zoomFactor > this.initialZoom) {
            // Zoom in
            console.log('Zoom in');
          } else {
            // Zoom out
            console.log('Zoom out');
          }
          this.drawBG(this.ctx2)


          // Update the initial zoom for the next touch move event
          this.initialZoom = zoomFactor;
        }
      },

      handleSliderChange(value) {
        // Do something with the new value
        console.log(1467,value)
        this.zoomLevel = 0.5 + 8.5 * value / 100;
        this.drawBG(this.ctx2)
      },
      /*
      handleCanvasWidth(value) {
        let width = this.inputW;//value.target.value;
        this.zoomLevel = this.w / width;
        this.inputH = Math.round(this.h / this.zoomLevel);
        this.drawBG(this.ctx2)
      },
      handleCanvasHeight(value) {
        let height = this.inputH;//value.target.value;
        this.zoomLevel = this.h / height;
        this.inputW = Math.round(this.w / this.zoomLevel);
        this.drawBG(this.ctx2)
      }    */  
    },

}
</script>

<style lang="scss">

  .table-container{
    z-index: 10;
  }

  .canvas-size {
    border: solid linen 1px;
  }

  .arch-container img {
    width: 50px;
    height: 17px;
  }

  .warp-container {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrap {
      position: relative;
      z-index: 2;
  }

  .wrap div {
      box-shadow: 2px 2px 6px -2px rgba(0,0,0,0.75);
  }
  .wrap2 {

      position: absolute;
      z-index: 1;
      background-color: 'white'
  }

  #mycanvas {
      display: block;
      box-sizing: border-box;
      border: 1px solid hsl(259, 100%, 65%)
  }
  #mycanvas2 {
      display: block;
      box-sizing: border-box;
  }

  .pointer {
      cursor: pointer;
  }

  .hand {
      cursor: grab;
  }

  /* Line */
  .line-h{
      position: fixed;
      height: 0px;
  }
  .line-v{
      position: fixed;
      width: 0px;
  }
  .top-line{
      border-top: dashed 2px #f700cb;
  }
  .bottom-line{
      border-bottom: dashed 2px #f700cb;
  }
  .right-line{
      border-right: dashed 2px #f700cb;
  }
  .left-line{
      border-left: dashed 2px #f700cb;
  }
  /* Anchor */
  .anchor{
      position: fixed;
      width: 40px;
      height: 40px;
      margin: -20px 0 0 -20px;
      background-color: #36313594;
      opacity: 0.8;
  }
  /* Rotate */
  .rotate{
      position: fixed;
      width: 40px;
      height: 40px;
      margin: -20px 0 0 -20px;
      background-color: blue;
      opacity: 0.5;
  }
</style>